import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';

const baseString = 'vra-zone-soil-item-full';
const classString = classNames({
  [`${baseString}`]: true
});
const ZoneSoilItemFull = ({
  soil
}) => {
  const { 'parsed-muname': displayName, 'drainage-class': drainage, percentage: { q: percentage} } = soil;
  const displayPercentage = percentage < 100
    ? getMessage('text__soil-percentage', { num: percentage })
    : null;

  return (
    <section className={classString}>
      <span>{displayName || getMessage('text__other')}</span>
      { drainage && (<span>{drainage} {displayPercentage}</span>) }
    </section>
  );
};
ZoneSoilItemFull.propTypes = {
  soil: PropTypes.object.isRequired
};
export default ZoneSoilItemFull;
